import { getCell, getName } from "utils/insightsAndAlarmsUtils";
import { dateRangeFilter, formatDateLocalTZ } from "utils/utils";
import { INSIGHT_HISTORY_TABLE_STRINGS } from "constants/constantStrings";

export const getInsightHistoryTableColDefs = filter => [
  {
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.insightName,
    flex: 2,
    editable: false,
    valueFormatter: getName,
    filter,
    defaultSort: "desc"
  },
  {
    field: "AnomalyType",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.tagName,
    flex: 1.5,
    editable: false,
    filter
  },
  {
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.insightDescription,
    flex: 2.5,
    editable: false,
    valueFormatter: params => getCell(params, "description"),
    filter
  },
  {
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.recommendation,
    flex: 3,
    editable: false,
    valueFormatter: params => getCell(params, "recommendation"),
    filter
  },
  {
    field: "CycleStartTime",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.startTime,
    flex: 2.5,
    editable: false,
    valueFormatter: params => formatDateLocalTZ(params.data?.CycleStartTime),
    filterParams: dateRangeFilter,
    filter: "agDateColumnFilter"
  },
  {
    field: "CycleEndTime",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.endTime,
    flex: 2.5,
    editable: false,
    valueFormatter: params => formatDateLocalTZ(params.data?.CycleEndTime),
    filterParams: dateRangeFilter,
    filter: "agDateColumnFilter"
  }
];
